import { Box, Heading } from 'grommet'
import styled from 'styled-components'

import BigOrangeHexagon from '@public/images/case-big-hexagon.svg'
import { NormalizedWrapper } from '@theme'

export const Content = styled(NormalizedWrapper)`
  max-width: 998px;
`

export const Hexagon = styled(BigOrangeHexagon)`
  position: absolute;
  right: ${({ theme }) => theme.spaces[0]};
  top: -284px;
  width: 896px;

  ${({ theme }) => theme.below.laptop`
    width: 696px;
    top: -320px;
  `}

  ${({ theme }) => theme.below.tablet`
    width: 596px;
    top: -360px;
  `}

  ${({ theme }) => theme.below.mobileL`
    width: 400px;
    top: -400px;
  `}
`
export const Wrapper = styled(Box)`
  position: relative;
  width: 100%;

  ${({ theme }) => theme.below.laptop`
    padding: ${theme.spaces[2]}px;
  `}
`
export const Header = styled(Heading)`
  color: ${({ theme }) => theme.colors.secondary};
  font-size: 60px;
  font-weight: ${({ theme }) => theme.fontWeight[7]};
  line-height: 80px;
  margin-bottom: 103px;
  margin-top: ${({ marginTop }) => marginTop};
  text-transform: uppercase;
  white-space: pre-wrap;
  z-index: 2;

  ${({ theme }) => theme.below.laptopM`
    margin-bottom: ${theme.spaces[5]}px;
  `}

  ${({ theme }) => theme.below.laptop`
   text-align:center;
  `}

  ${({ theme }) => theme.below.tablet`
    margin-top: ${theme.spaces[4]}px;
    margin-bottom: ${theme.spaces[4]}px;
  `}

  ${({ theme }) => theme.below.tablet`
    font-size: ${({ theme }) => theme.fontSizes[7]}px;
    line-height: 64px;
  `}

  ${({ theme }) => theme.below.tabletXS`
    font-size: ${({ theme }) => theme.fontSizes[6]}px;
    line-height: 48px;
  `}

  ${({ theme }) => theme.below.mobileL`
    font-size: ${({ theme }) => theme.fontSizes[5]}px;
    line-height: 40px;
  `}

  ${({ theme }) => theme.below.mobileS`
    font-size: ${({ theme }) => theme.fontSizes[15]}px;
    line-height: 32px;
  `}
`
export const HexagonWrapper = styled(Box)`
  align-self: flex-end;
  position: relative;
  width: 60%;
`
